import { useMutation } from '@gogame/query';

import { exportAffiliates } from 'scenes/Affiliates/sources/affiliates';

import { exportAffs } from '../queryKeyFactory';

export const useExportAffiliates = () => {
  const exportMutation = useMutation(exportAffs(), exportAffiliates, {
    refresh: false,
    mutateMessage: () => 'Download has started',
    successMessage: () => 'Download complete',
  });

  const handleAction = async (params) => {
    await exportMutation.mutateAsync(params);
  };

  return [handleAction, exportMutation];
};
